// Bane 5: Når vinden sover (2046). Vendsyssel og Himmerland fra Hjørring til Tjele.
// Nyt: Ring til Norge (norsk vandkraft lander i Tjele) og vindstille, hvor vind og sol næsten går i stå
// i 20 s. Finalen: en lang vindstille, en ankerbåd og en storm oven i.
// Skagerrak lander ved Tjele, og 400 kV-ledningen op til Ferslev står der fra start (spilværdi).

import type { LevelDef } from '../../sim/types';

export const LEVEL_05: LevelDef = {
  id: '05-naar-vinden-sover',
  number: 5,
  title: 'Når vinden sover',
  year: 2046,
  intro: 'Nordjylland kører på vind. Men en dag i januar holder vinden fri. Heldigvis har Norge vand i bjergene.',
  view: [68, 28, 168, 156],
  greenGoalPct: 76,
  sites: [
    { node: 'aalborg', kind: 'city', tier: 2, maxTier: 2 },
    { node: 'ferslev', kind: 'station' },
    { node: 'tjele', kind: 'station' },
    { node: 'noerrekaer', kind: 'wind', name: 'Nørrekær Vind', capMw: 600, fee: 4 },
    // Det gamle kulværk er reserve: det kører kun, når intet andet kan, og tæller ikke som grønt.
    { node: 'nordjyllandsvaerket', kind: 'plant', name: 'Reserveværket', capMw: 400, green: 0 },
    { node: 'hjoerring', kind: 'city', tier: 0, maxTier: 2, at: [8, 15] },
    // Kunder i køen, i den rækkefølge de dukker op.
    { node: 'broenderslev', kind: 'city', tier: 0, maxTier: 2, at: 'pool' },
    // Havvinden i Jammerbugten går i land ved Blokhus.
    { node: 'blokhus', kind: 'city', tier: 0, maxTier: 1, at: 'pool' },
    { node: 'jammerbugt', kind: 'offshore', name: 'Jammerbugt Havvind', capMw: 800, fee: 8, at: 'pool' },
    { node: 'hobro', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'dronninglund', kind: 'solar', name: 'Solpark Dronninglund', capMw: 300, at: 'pool' },
    { node: 'frederikshavn', kind: 'city', tier: 1, maxTier: 2, at: 'pool' },
    { node: 'vester_hassing', kind: 'station', at: 'pool' },
    { node: 'hvam', kind: 'wind', name: 'Hvam Vind', capMw: 400, at: 'pool' },
    { node: 'aars', kind: 'city', tier: 0, maxTier: 2, at: 'pool' },
  ],
  // 400 kV fra Tjele op til Ferslev og videre til Aalborg: vejen, norsk vandkraft kommer ad.
  lines: [
    { a: 'tjele', b: 'ferslev', medium: 'air', tier: 2 },
    { a: 'ferslev', b: 'aalborg', medium: 'air', tier: 2 },
  ],
  mechanics: ['air', 'upgrade', 'double', 'cable', 'sea', 'crew', 'reinforce', 'station', 'shoo', 'battery', 'wishes', 'fcr', 'shed', 'norway'],
  eventMenu: ['storm', 'digger', 'anchor', 'protest', 'heatwave', 'dunkelflaute'],
  // Ét nyt i hvert år: vindstillen (scriptet i år 1), naboerne, varmen eller ankerbåden, gravkoen eller
  // elbilerne, og til sidst stormen. Kan en nyhed ikke ramme noget endnu, kommer den anden.
  news: [['dunkelflaute'], ['protest'], ['heatwave', 'anchor'], ['digger', 'spike'], ['storm']],
  scripted: [
    // Den første vindstille midt i år 1: mild, så Ring til Norge kan prøves uden at noget går i sort.
    { kind: 'dunkelflaute', at: [30, 38], strength: 1 },
    // Finalen: en lang, dyb vindstille, og mens den står på, kommer en ankerbåd og en storm.
    { kind: 'dunkelflaute', at: 4, strength: 2, finale: true },
    { kind: 'anchor', at: 14, warnS: 8, finale: true },
    { kind: 'storm', at: 26, finale: true },
  ],
  growth: [],
  boosts: [],
  years: 5,
  finaleS: 40,
  clockFrozenUntilYear: 0,
  startCrews: 1,
  startKr: 20,
  shipHome: 'aalborg',
  crewHome: 'aalborg',
  packs: [
    ['big_battery', 'two_crews'],
    ['free_air3', 'cable_discount'],
    ['big_battery', 'town_meeting'],
    ['two_crews', 'free_air3'],
    ['free_station', 'big_battery'],
  ],
};
